export class TaxExemption {
    tax_exemption_id: string = null;
    reason: string = null;
    description: string = null;
    type: any = null;
    organization_id: string = null;
    created_by: string = null;
}
